import axios from "axios";
import qs from "query-string";

import { getAccountApi } from "../../../includes/util";


const createApiConfig = (token) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token.access_token,
  };
  return headers;
};

export const Login = (userName, password) => {
  return axios
    .post(
      getAccountApi() + "/token",
      qs.stringify({
        grant_type: "password",
        scope: "customer",
        username: userName,
        password: password,
      }),
      {
        headers: {
          "Content-Type": "x-www-form-urlencoded",
          accept: "application/json",
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getLoginBySSOToken = (token) => {
  //console.log('getLoginBySSOToken', token);
  return axios
    .get(getAccountApi() + "/identity/singlesignon/token/" + token)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getUserInformation = (token) => {
  //console.log('getUserInformation.start');

  return axios
    .get(getAccountApi() + "/identity/loggedinuser", {
      headers: createApiConfig(token),
    })
    .then((response) => {
      //console.log('getUserInformation.response', response);
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};



export const getMenu = (token) => {
  //console.log('getUserInformation.start');

  return axios
    .get(getAccountApi() + "/identity/menu", {
      headers: createApiConfig(token),
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const getLoginUserRolePermission = (token) => {
  return axios
    .get(getAccountApi() + "/identity/rolepermission", {
      headers: createApiConfig(token),
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};